import styled, { css } from 'styled-components';
import { MdChevronRight } from 'react-icons/md';
import { withRouter } from 'react-router';
import { spacing, size, media, NavLink } from 'ui';
import { capitalizeFirstLetter } from 'utils';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div`
  background-color: #fff;
  height: 58px;
  top: 60px;
  right: 0;
  box-shadow: 0 1px 0 #e0e4e8;
  padding: ${spacing()};
  font-size: ${size(1)};
  line-height: 26px;
  text-align: center;
  font-weight: 500;
  display: none;

  ${media.tablet`
    display: block;
    left: 550px;
    min-height: 68px;     

    ${props =>
      props.barePaddingVertical &&
      css`
        padding-bottom: ${spacing(0.5)};
        padding-top: ${spacing(0.5)};
      `}
  `};

    ${media.desktop`
    left: 670px;
    min-height: 68px;
  `};
`;

const WrapperMembers = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: ${({ theme }) => theme.spacing(2)};
  padding-right: ${({ theme }) => theme.spacing(2)};
`;

const WrapperTitle = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MembersLengthLink = styled(NavLink)`
  font-size: ${size(-1)};
  color: ${({ theme }) => theme.primary};
  line-height: 1.2;
`;

const MessagesHeader = ({ displayName, match, members }) => {
  const { t } = useTranslation();

  return (
    <Wrapper barePaddingVertical={members.length >= 2}>
      <WrapperMembers>
        <WrapperTitle>{capitalizeFirstLetter(displayName)}</WrapperTitle>

        {members.length >= 2 && (
          <MembersLengthLink
            to={`/mes-echanges/mes-messages/${match.params.id}/details`}
          >
            {members.length} {t('forum:members')}
            <MdChevronRight />
          </MembersLengthLink>
        )}
      </WrapperMembers>
    </Wrapper>
  );
};

export default withRouter(MessagesHeader);
